// extracted by mini-css-extract-plugin
export default {"block":"EmptyImages_block__6TcQo"};